/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { adminOpenRouterKeysListKeys } from "../funcs/adminOpenRouterKeysListKeys.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListKeysResponseBody2 } from "../models/components/listkeysresponsebody2.js";
import {
  ListAdminOpenRouterKeysRequest,
  ListAdminOpenRouterKeysSecurity,
} from "../models/operations/listadminopenrouterkeys.js";
import { unwrapAsync } from "../types/fp.js";
export type AdminOpenRouterKeysQueryData = ListKeysResponseBody2;

export function prefetchAdminOpenRouterKeys(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListAdminOpenRouterKeysRequest | undefined,
  security?: ListAdminOpenRouterKeysSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildAdminOpenRouterKeysQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildAdminOpenRouterKeysQuery(
  client$: GramCore,
  request?: ListAdminOpenRouterKeysRequest | undefined,
  security?: ListAdminOpenRouterKeysSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<AdminOpenRouterKeysQueryData>;
} {
  return {
    queryKey: queryKeyAdminOpenRouterKeys({
      gramSession: request?.gramSession,
    }),
    queryFn: async function adminOpenRouterKeysQueryFn(
      ctx,
    ): Promise<AdminOpenRouterKeysQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(adminOpenRouterKeysListKeys(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyAdminOpenRouterKeys(
  parameters: { gramSession?: string | undefined },
): QueryKey {
  return ["@gram/client", "adminOpenRouterKeys", "listKeys", parameters];
}
